// Strapi
import { article, blocks, seo } from '@/services/strapiPopulate';
import { fetchStrapiContentWithBlocks } from '@/services/blocks/fetchStrapiContentWithBlocks';

// ZOD
import * as z from 'zod';
import { ArticlesType, ArticlesZod, ArticleType, ArticleZod } from '@/types/Blog/ArticleType';

// Client
import client from '../client';

const ArticleSlugZod = z.object({
  slug: z.string(),
});

export type ArticleSlugType = z.infer<typeof ArticleSlugZod>;

export const getArticleSlugs = async (): Promise<ArticleSlugType[]> => {
  const pageSize = 100;
  const response = await client.get('/api/articles', {
    params: {
      fields: ['slug'],
      pagination: {
        page: 1,
        pageSize,
      },
    },
  });

  const totalPages = response.data?.meta?.pagination.pageCount || 1;
  const allData = [...(response.data?.data ?? [])];

  if (totalPages > 1) {
    const pagePromises = Array.from({ length: totalPages - 1 }, (_, i) =>
      client.get('/api/articles', {
        params: {
          fields: ['slug'],
          pagination: { page: i + 2, pageSize },
        },
      }),
    );
    const results = await Promise.all(pagePromises);
    results.forEach((r) => allData.push(...(r.data?.data || [])));
  }

  return z.array(ArticleSlugZod).parseAsync(allData);
};

export const getArticles = async (): Promise<ArticlesType> =>
  fetchStrapiContentWithBlocks('/api/articles', ArticlesZod, { article, blocks, seo }, 'Articles');

export const getArticle = async (slug: string): Promise<ArticleType> =>
  fetchStrapiContentWithBlocks(`/api/articles/${slug}`, ArticleZod, { article, blocks, seo }, 'Article');
